import { ILineItem, OnUpdateLine } from '@features/purchasing/my-basket/types';
import Image from '@store/components/Image';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps extends ILineItem {
  onUpdate: OnUpdateLine;
}

export default function Line(props: IProps) {
  const { t } = useTranslation();

  const [unitCount, setUnitCount] = useState(props.unitCount);

  const onUpdate = useCallback(
    (unitCount: number) => {
      const { productId, optionId, onUpdate } = props;

      onUpdate({ productId, optionId, unitCount });
    },
    [props]
  );

  return (
    <div className="basket-line">
      <div className="column product">
        <a
          href={props.productUrl}
          className="w-24 laptop:w-16 h-24 laptop:h-16 flex items-center justify-center shrink-0 overflow-hidden">
          <Image
            src={props.imageUrl}
            alt={props.productName}
            className="max-h-full object-scale-down"
          />
        </a>

        <div className="h-full flex flex-col flex-auto items-start gap-y-2 pl-2 pr-6">
          <a
            href={props.productUrl}
            className="block text-xs laptop:text-base font-medium leading-normal">
            {props.productName}
          </a>

          <div className="flex flex-col text-xs laptop:text-sm gap-y-1">
            <div className="flex gap-x-2">
              <span className="text-gray-400">{t('ProductCode')}</span>
              <span className="font-medium">{props.productCode}</span>
            </div>
            {props.brand && (
              <div className="flex gap-x-2">
                <span className="text-gray-400">{t('Brand')}</span>
                <span className="font-medium">{props.brand}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="column availability">{props.availability}</div>

      <div className="column unit-count">
        <input
          type="number"
          inputMode="numeric"
          name="unitCount"
          min={1}
          defaultValue={props.unitCount}
          onChange={e => {
            const count = parseInt(e.currentTarget.value);
            setUnitCount(count);
          }}
          onBlur={() => {
            if (isNaN(unitCount) || unitCount === props.unitCount) return;
            onUpdate(unitCount);
          }}
          className="as-text w-full w-16 h-8 px-1 text-center text-xs laptop:text-sm"
        />
      </div>
      <div className="column price">
        <span className="text-xs laptop:text-sm font-medium">
          {props.unitPrice.formatted} / {props.measurementUnit}
        </span>
        <span className="text-sm laptop:text-base text-price font-medium">
          {props.linePrice.formatted}
        </span>
        {props.lineSaving && props.lineSaving.value > 0 && (
          <div className="text-xs laptop:text-sm text-price-discount">
            <span className="mr-1">{t('YourSaving')}</span>
            <span className="font-medium">{props.lineSaving.formatted}</span>
          </div>
        )}
      </div>

      <div className="column delete">
        <button
          className="w-6 h-6 absolute laptop:relative top-1 right-0 inline-flex items-center justify-center bg-gray-200 rounded-full text-gray-600 text-xxs"
          onClick={() => onUpdate(0)}
          type="button">
          <i className="fa-solid fa-times" />
        </button>
      </div>
    </div>
  );
}
